import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { LOG_OUT } from "config/constants";
import { Constants } from "../../common/constants";
const NavLink = props => (
  <Link
    to={props.to}
    className={
      window.location.pathname.slice(0, props.to.length) === `${props.to}`
        ? `nav__Link activeLink`
        : "nav__Link"
    }
    onClick={() => {
      if (props.to === "/gyms/") {
        localStorage.removeItem("gyms")
        localStorage.removeItem("currentGymPage")
        localStorage.removeItem("searchQuery")
        window.location.assign("/gyms/");
      } else if (props.to === "/vpt/") {
        localStorage.removeItem(Constants.STATE_VPT_HOME);
        localStorage.removeItem(Constants.STATE_VPT_TRAINERS);
        localStorage.removeItem(Constants.STATE_VPT_BOOKINGS);
      } else if (props.to === "/promocodes/") {
        localStorage.removeItem(Constants.STATE_PROMOCODES);
        window.location.assign("/promocodes/");
      } else if (props.to === "/users/") {
        localStorage.removeItem(Constants.STATE_USERS);
        window.location.assign("/users/");
      }
    }}
  >
    {props.children}
  </Link>
);
const Navbar = props => {
  const restricted_access = localStorage.getItem("restricted_access");
  const access_level = localStorage.getItem("access_level");
  const email = localStorage.getItem('email');
  return (
    <nav className="nav__Main">
      <div
        style={{
          borderBottom: "2px solid var(--primary)",
          display: "flex",
          padding: "0em 1em 4vh 1em",
          margin: "0em 1em 0vh 1em",
          alignItems: "center"
        }}
      >
        <div style={{ flex: restricted_access === "true" ? 10 : 4 }}>
          <img
            src={require("assets/images/logo-dark.png")}
            width={"100%"}
            alt="Logo Dark"
          />
        </div>
        <div className="nav__Tabs">
          <NavLink to="/users/">Users</NavLink>
          <NavLink to="/gyms/">Gyms</NavLink>
          {restricted_access === "true" ? null : <NavLink to="/sessions/">Sessions</NavLink>}
          <NavLink to="/trainers/">Trainers</NavLink>
          {restricted_access === "true" ? null : <NavLink to="/workouts/">Custom Workouts</NavLink>}
          <NavLink to="/vpt/">VPT</NavLink>
          {restricted_access === "true" ? null : <NavLink to="/onboarding/">Onboarding</NavLink>}
          {restricted_access === "true" ? null : <NavLink to="/analytics/">Analytics</NavLink>}
          {restricted_access === "true" ? null : <NavLink to="/postWorkoutData/">Post Workout</NavLink>}
          {restricted_access === "true" ? null : <NavLink to="/dynamicPricing/">Dynamic Pricing</NavLink>}
          <NavLink to="/walletPrices/">Wallet Prices</NavLink>
          <NavLink to="/promocodes/">Promocodes</NavLink>
          {restricted_access === "true" ? null : <NavLink to="/adminConfig/">Config</NavLink>}
          {restricted_access === "true" ? null : <NavLink to="/qrlist/">QR List</NavLink>}
          {restricted_access === "true" ? null : <NavLink to="/log/">Access</NavLink>}
          {access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_1 ? <NavLink to="/admins/">Admin Users</NavLink> : null}
          {restricted_access === "true" ? null : <NavLink to="/flat-rate/">Rates</NavLink>}
        </div>
        <div
          style={{
            flex: 2,
            display: "flex",
            justifyContent: "flex-end",
            cursor: "pointer"
          }}
          onClick={LOG_OUT}
        >
          <img
            src={require("assets/images/logout-btn.png")}
            height="20vw"
            alt="Logout"
          />
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
